module.exports = __webpack_public_path__ + "img/waving-hand.fe01223b.svg";